import { render, staticRenderFns } from "./connectors.vue?vue&type=template&id=548d16a0&"
import script from "./connectors.ts?vue&type=script&lang=js&"
export * from "./connectors.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports